// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__D29Lq","demoSection":"Checkbox_demoSection__Li4bb","demoGrid":"Checkbox_demoGrid__Hgn08","demoWrapper":"Checkbox_demoWrapper__AMhVu"};